import { render, staticRenderFns } from "./POAutocomplete.vue?vue&type=template&id=6ed54f9c"
import script from "./POAutocomplete.vue?vue&type=script&lang=js"
export * from "./POAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports